import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Providers } from './app/providers';
import { router } from './app/router';
import { useAuthStore } from './features/auth/auth-store';

export default function App() {
  const bootstrap = useAuthStore((s) => s.bootstrap);

  // Restore any persisted session before the router decides on guards.
  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  );
}
